import { fromLonLat } from "ol/proj";
import { get_aoi_extent } from "../../api/ApiAOI";

class AOIService {
  static center_map_from_extent = (map, extent) => {
    map.getView().fit(extent, {
      size: map.getSize(),
      padding: [100, 100, 150, 100],
    });
  };

  static center_map_from_extent_smoothly = (map, extent) => {
    const view = map.getView();

    // Obtener el centro del extent
    const center = [
      (extent[0] + extent[2]) / 2, // (minX + maxX) / 2
      (extent[1] + extent[3]) / 2, // (minY + maxY) / 2
    ];

    // Obtener el zoom óptimo para que encaje el extent en la vista
    const resolution = view.getResolutionForExtent(extent, map.getSize());

    // Animar el movimiento de la vista
    view.animate({
      center: center,
      zoom: view.getZoomForResolution(resolution) - 0.5, // Calcula el zoom adecuado
      duration: 1000, // Duración de la animación en ms
    });
  };

  static get_aoi_extent = async (filtroCQL) => {
    return get_aoi_extent(filtroCQL);
  };

  /**
   * Calcula el BBOX (extent) en EPSG:4326 dadas unas coordenadas centrales, un zoom y un tamaño en píxeles.
   * ¡Ojo! Esto es un cálculo aproximado basado en la lógica de "mapas tipo OSM".
   * @param {number} centerLon - Longitud del centro (en grados).
   * @param {number} centerLat - Latitud del centro (en grados).
   * @param {number} zoom      - Nivel de zoom (0, 1, 2...).
   * @param {number} mapWidthPx  - Ancho en píxeles del “viewport”.
   * @param {number} mapHeightPx - Alto en píxeles del “viewport”.
   * @returns {[number, number, number, number]} - [minLon, minLat, maxLon, maxLat]
   */
  static getExtentFromCenterZoomEPSG4326(
    centerLon,
    centerLat,
    zoom,
    mapWidthPx,
    mapHeightPx
  ) {
    // Grados por pixel en zoom 0 (tomando 360° / 256px como base)
    const degreesPerPixelZoom0 = 360 / 256; // 1.40625 aprox.

    // Grados por pixel en el zoom solicitado
    const degreesPerPixel = degreesPerPixelZoom0 / Math.pow(2, zoom);

    // Mitad del tamaño en píxeles → lo convertimos a grados
    const halfWidthDeg = (mapWidthPx / 2) * degreesPerPixel;
    const halfHeightDeg = (mapHeightPx / 2) * degreesPerPixel;

    // Calculamos el bounding box
    const minLon = centerLon - halfWidthDeg;
    const maxLon = centerLon + halfWidthDeg;
    const minLat = centerLat - halfHeightDeg;
    const maxLat = centerLat + halfHeightDeg;

    return [minLon, minLat, maxLon, maxLat];
  }

  // Centra el mapa en la ubicación del usuario con animación
  static center_map_on_user = (map) => {
    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const userCoords = [
            position.coords.longitude,
            position.coords.latitude,
          ];
          const userCoords3857 = fromLonLat(userCoords); // Convertimos a EPSG:3857

          const view = map.getView();
          view.animate({
            center: userCoords3857,
            zoom: 14, // Puedes ajustar el zoom a tu necesidad
            duration: 1000, // Animación en 1 segundo
          });
        },
        (error) => {
          console.error("Error obteniendo la ubicación:", error.message);
        },
        {
          enableHighAccuracy: true, // Más precisión si está disponible
          timeout: 10000, // Espera hasta 10s
          maximumAge: 0, // No usa caché de ubicaciones antiguas
        }
      );
    } else {
      console.error("Geolocalización no es soportada en este navegador.");
    }
  };
}

export { AOIService };
